import gql from 'graphql-tag';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class FormatoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetFormatosByCodigo(rutEmpresa, callback) {
        this.gqlclient.query({
            query: gql `
        query ($empresa_rut: Decimal) {
            formato {
              obtenerSegunFiltro(filtro: {exacto: {empresa_rut: $empresa_rut, codigo: "-1", nombre: ""}}) {
                respuesta {
                  registros {
                    codigo
                    empresa_rut
                    nombre
                    cantidad
                    formato_padre
                    fecha_registro
                    rut_usuario_creacion
                    rut_usuario_modificacion
                    es_compra
                    es_venta
                  }
                }
              }
            }
          }
        `,
            variables: {
                empresa_rut: rutEmpresa
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
            //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
            // );
            // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
            // } else {
            //   alert(notificacion.mensajes[0].texto);
            // }
            const { mensajes, respuesta } = response.data.formato.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    GetFormatosByComb1(rutEmpresa, callback) {
        this.gqlclient.query({
            query: gql `
        query ($empresa_rut: Decimal) {
          formato {
            obtenerFormatosComb1(empresa_rut: $empresa_rut) {
              respuesta {
                registros {
                  codigo
                  empresa_rut
                  nombre
                  cantidad
                  formato_padre
                  fecha_registro
                  rut_usuario_creacion
                  rut_usuario_modificacion
                  es_compra
                  es_venta
                  formato_comb
                }
              }
            }
          }
        }
        `,
            variables: {
                empresa_rut: rutEmpresa
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
            //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
            // );
            // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
            // } else {
            //   alert(notificacion.mensajes[0].texto);
            // }
            const { mensajes, respuesta } = response.data.formato.obtenerFormatosComb1;
            let { registros } = respuesta;
            if (respuesta && respuesta.registros) {
                registros = _.orderBy(registros, ['formato_comb', 'nombre'], ['desc', 'asc']);
                registros.map(formato => {
                    if (formato.formato_comb) {
                        formato.nombre = `${formato.nombre}`;
                    }
                });
            }
            callback({ mensajes, respuesta });
        });
    }
    GetFormatosByComb2(rutEmpresa, callback) {
        this.gqlclient.query({
            query: gql `
        query ($empresa_rut: Decimal) {
          formato {
            obtenerFormatosComb2(empresa_rut: $empresa_rut) {
              respuesta {
                registros {
                  codigo
                  empresa_rut
                  nombre
                  cantidad
                  formato_padre
                  fecha_registro
                  rut_usuario_creacion
                  rut_usuario_modificacion
                  es_compra
                  es_venta
                  formato_comb
                }
              }
            }
          }
        }
        `,
            variables: {
                empresa_rut: rutEmpresa
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
            //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
            // );
            // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
            // } else {
            //   alert(notificacion.mensajes[0].texto);
            // }
            const { mensajes, respuesta } = response.data.formato.obtenerFormatosComb2;
            let { registros } = respuesta;
            if (respuesta && respuesta.registros) {
                registros = _.orderBy(registros, ['formato_comb', 'nombre'], ['desc', 'asc']);
                registros.map(formato => {
                    if (formato.formato_comb) {
                        formato.nombre = `${formato.nombre}`;
                    }
                });
            }
            callback({ mensajes, respuesta });
        });
    }
}
FormatoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormatoService_Factory() { return new FormatoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: FormatoService, providedIn: "root" });
